import BaseApi from "./BaseApi";
import { logError } from "../utils/errorLogger";
import { unwrapPaginatedResponse, buildPaginationParams } from "../utils/paginatedApi";
class HotelFournisseurApi extends BaseApi {
  constructor() {
    super("fournisseur");
  }
  async getAllFournisseurs() {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}`);
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async getFournisseursPage({ page = 1, limit = 10, filters = {} } = {}) {
    try {
      const response = await this.getApiInstance(true).get(`/${this.endpoint}`, {
        params: {
          ...buildPaginationParams({ page, limit }),
          ...filters,
        },
      });
      return unwrapPaginatedResponse(response.data);
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get a single client by ID
  async getFournisseurById(id) {
    try {
      const response = await this.getApiInstance(true).get(
        `/${this.endpoint}/${id}`
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Create a new client
  async createFournisseur(fournisseurData) {
    try {
      const response = await this.getApiInstance(true).post(
        `/${this.endpoint}`,
        fournisseurData
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Update a fournisseur
  async updateFournisseur(id, fournisseurData) {
    try {
      const response = await this.getApiInstance(true).put(
        `/${this.endpoint}/${id}`,
        fournisseurData
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Delete a fournisseur
  async deleteFournisseur(id) {
    try {
      const response = await this.getApiInstance(true).delete(
        `/${this.endpoint}/${id}`
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Search fournisseurs
  async searchFournisseurs(query) {
    try {
      const response = await this.getApiInstance(true).get(
        `/${this.endpoint}/search?query=${encodeURIComponent(query)}`
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // Get fournisseurs by type
  async getFournisseursByType(type) {
    try {
      const response = await this.getApiInstance(true).get(
        `/${this.endpoint}/type/${encodeURIComponent(type)}`
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // --- Banques ---
  async getAllBanques() {
    try {
      const response = await this.getApiInstance(true).get(
        "/fournisseur_configuration/banques"
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async getBanqueById(id) {
    try {
      const response = await this.getApiInstance(true).get(
        `/fournisseur_configuration/banques/${id}`
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async createBanque(data) {
    try {
      const response = await this.getApiInstance(true).post(
        "/fournisseur_configuration/banques",
        data
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async updateBanque(id, data) {
    try {
      const response = await this.getApiInstance(true).put(
        `/fournisseur_configuration/banques/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async deleteBanque(id) {
    try {
      const response = await this.getApiInstance(true).delete(
        `/fournisseur_configuration/banques/${id}`
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // --- Types Fournisseurs ---
  async getAllTypesFournisseurs() {
    try {
      const response = await this.getApiInstance(true).get(
        "/fournisseur_configuration/type_fournisseur"
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async getTypesFournisseurById(id) {
    try {
      const response = await this.getApiInstance(true).get(
        `/fournisseur_configuration/type_fournisseur/${id}`
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async createTypesFournisseur(data) {
    try {
      const response = await this.getApiInstance(true).post(
        "/fournisseur_configuration/type_fournisseur",
        data
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async updateTypesFournisseur(id, data) {
    try {
      const response = await this.getApiInstance(true).put(
        `/fournisseur_configuration/type_fournisseur/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async deleteTypesFournisseur(id) {
    try {
      const response = await this.getApiInstance(true).delete(
        `/fournisseur_configuration/type_fournisseur/${id}`
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // --- Postes ---

  async getAllPostes() {
    try {
      const response = await this.getApiInstance(true).get(
        "/fournisseur_configuration/postes"
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async getPosteById(id) {
    try {
      const response = await this.getApiInstance(true).get(
        `/fournisseur_configuration/postes/${id}`
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async createPoste(data) {
    try {
      const response = await this.getApiInstance(true).post(
        "/fournisseur_configuration/postes",
        data
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async updatePoste(id, data) {
    try {
      const response = await this.getApiInstance(true).put(
        `/fournisseur_configuration/postes/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async deletePoste(id) {
    try {
      const response = await this.getApiInstance(true).delete(
        `/fournisseur_configuration/postes/${id}`
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // --- Conditions de Paiement ---
  async getAllConditionsPaiement() {
    try {
      const response = await this.getApiInstance(true).get(
        "/fournisseur_configuration/conditions_paiement"
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async getConditionPaiementById(id) {
    try {
      const response = await this.getApiInstance(true).get(
        `/fournisseur_configuration/conditions_paiement/${id}`
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async createConditionPaiement(data) {
    try {
      const response = await this.getApiInstance(true).post(
        "/fournisseur_configuration/conditions_paiement",
        data
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async updateConditionPaiement(id, data) {
    try {
      const response = await this.getApiInstance(true).put(
        `/fournisseur_configuration/conditions_paiement/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async deleteConditionPaiement(id) {
    try {
      const response = await this.getApiInstance(true).delete(
        `/fournisseur_configuration/conditions_paiement/${id}`
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async deletefileFournisseur(url, directory) {
    try {
      const response = await this.getApiInstance(true).delete(
        `/file/fournisseurFile`,
        {
          data: { url, directory },
        }
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  // --- Produits ---
  async getAllProduits() {
    try {
      const response = await this.getApiInstance(true).get(
        "/facture/produits"
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async getActiveProduits() {
    try {
      const response = await this.getApiInstance(true).get(
        "/facture/produits/active"
      );
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }
}

export default new HotelFournisseurApi();
